module.exports = __webpack_public_path__ + "static/assets/16b5756c1aee82f1c5023e2458e4ad02.png";